
@if (isAddCommission) {
  <button class="btn btn-success" (click)="switchScreen()">Liste comission</button>
}
@if (isAddCommission) {
  <div class="container d-flex justify-content-center align-items-center" id="addCommission">
    <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;" (ngSubmit)="onAddCommission()"
      [formGroup]="addCommForm">
      <h2 class="mb-4">Remplir details commission</h2>
      <div class="form-group form-floating">
        <select formControlName="partnerType" class="ml-2 mr-2 mt-2 form-select" (change)="loadPartners()">
          <option value="">Choisir le type de partenaire</option>
          <option value="MERCHANT">marchand</option>
          <option value="PROVIDER">partner moyen de paiement</option>
        </select>
        <label>Choisir le type de partenaire</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="partner" class="ml-2 mr-2 mt-2 form-select">
          <option value="">Choisir le partenaire</option>
          @for (pp of partners; track $index) {
            <option value="{{pp.id}}">{{pp.name}}</option>
          }
        </select>
        <label>Choisir le partenaire</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="transactionType" class="ml-2 mr-2 mt-2 form-select">
          <option value="">Choisir le type d'operation</option>
          @for (op of trxTypes ; track $index) {
            <option value="{{op.code}}">{{op.libelle}}</option>
          }
        </select>
        <label>Choisir le type d'operation</label>
      </div>
      <div class="form-group form-floating">
        <input type="number" class="ml-2 mr-2 mt-2 form-control" id="flatAmount" formControlName="flatAmount"
          placeholder="Entrer un montant forfait">
        <label>Entrer un montant forfait</label>
      </div>
      <div class="form-group form-floating">
        <input type="number" class="ml-2 mr-2 mt-2 form-control" id="amount" formControlName="amount"
          placeholder="Entrer le montant de la commission">
        <label>Entrer le montant de la commission</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="type" class="ml-2 mr-2 mt-2 form-select">
          <option value="">Choisir le type de commission</option>
          <option value="P">Pourcentage</option>
          <option value="F">Fixe</option>
        </select>
        <label>Choisir le type de commission</label>
      </div>
      <div class="form-group form-floating">
        <input type="number" class="ml-2 mr-2 mt-2 form-control" id="limitInf" formControlName="limitInf"
          placeholder="Entrer la borne inferieure">
        <label>Entrer la borne inferieure</label>
      </div>
      <div class="form-group form-floating">
        <input type="number" class="ml-2 mr-2 mt-2 form-control" id="limitSup" formControlName="limitSup"
          placeholder="Entrer la borne sup&#233;rieure">
        <label>Entrer la borne sup&#233;rieure</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="paymentMode" class="ml-2 mr-2 mt-2 form-select" (change)="loadPaymentModes()">
          <option value="">Choisir le mode de Paiement</option>
          @for (mode of paymentModes; track mode) {
            <option value="{{mode.code}}">{{mode.name}}</option>
          }
        </select>
        <label>Choisir le mode de Paiement</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="paymentNetwork" class="ml-2 mr-2 mt-2 form-select">
          @for (sub of paymentNetworks; track sub) {
            <option value="{{sub.code}}">{{sub.network}}</option>
          }
        </select>
        <label>Choisir le r&#233;seau moyen de paiement</label>
      </div>
      <div class="form-group">
        <div class="form-check form-switch">
          <input class="form-check-input bg-checked-success" type="checkbox" role="switch" id="payedByCustomer" (change)="onPayedByCustomer($event)">
          <label class="form-check-label d-flex align-items-left" for="payedByCustomer">Payer par le client</label>
        </div>
      </div>
      <button type="submit" class="btn btn-success btn-block mt-3" [disabled]="!this.addCommForm.valid">Valider</button>
    </form>
  </div>
}
@if (!isAddCommission) {
  <form [formGroup]="addCommForm" class="row p-4">
    @if(connectedUser?.role?.code=='SCHOOLS_MANAGER'){
      <input type="hidden" formControlName="idCommission">
      <input type="hidden" formControlName="partnerType" value="MERCHANT">
      }@else {
      <div class="row">
        <div class="col-5">
          <input type="hidden" formControlName="idCommission">
        </div>
        <div class="col-3 form-floating">
          <select formControlName="partnerType" class="ml-2 mr-2 mt-2 form-select" (change)="loadPartners()">
            <option value="">Choisir le type partenaire</option>
            <option value="MERCHANT">marchand</option>
            <option value="PROVIDER">Provider moyen de paiement</option>
          </select>
          <label>Choisir le type partenaire</label>
        </div>
      </div>
    }
    <div class="row">
      @if(connectedUser?.role?.code=='SCHOOLS_MANAGER'){
        <div class="col-5"></div>
        }@else {
        <div class="col-5">
          @if (!isAddCommission) {
            <button class="btn btn-success mt-2" (click)="switchScreen()">Ajouter
            commission</button>
          }
        </div>
      }
      <div class="form-floating col-3 d-flex justify-content-center">
        <select formControlName="partner" class="ml-2 mr-2 mt-2 form-select" (change)="loadCommissions()">
          <option value="">Choisir le partenaire</option>
          @for (pp of partners; track pp) {
            <option value="{{pp.id}}">{{pp.name}}</option>
          }
        </select>
        <label>Choisir le partenaire</label>
      </div>
    </div>
  </form>
}
@if (!isAddCommission) {
  <div id="listCommission" class="container justify-content-center d-flex align-items-center">
    <table class="table table-bordered table-hover table-striped text-center">
      <thead class="table-success">
        <tr>
          <th>Montant</th>
          <th>Borne inf</th>
          <th>Borne sup</th>
          <th>operation</th>
          <th>mode payment</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for (com of commissions; track com) {
          <tr>
            <td>{{com.amount}}</td>
            <td>{{com.limitInf}}</td>
            <td>{{com.limitSup}}</td>
            <td>{{com.transactionType.libelle}}</td>
            <td>{{com.paymentMode?.network}}</td>
            <td>
              <button type="button" class="btn btn-success" (click)="commissionDetails(com)">Details</button>
              @if(connectedUser?.role?.code!='SCHOOLS_MANAGER'){
                <button type="button" class="btn btn-warning" (click)="editCommission(com)">Modifier</button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
<div class="modal" tabindex="-1" role="dialog" id="detailsCommission">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-success round">
        <h3 class="d-flex justify-content-center align-items-center text-white">details commission</h3>
      </div>
      <div class="modal-body">
        <div><span class="fs-3">Montant de la commission : </span><span
      class="fs-2 fw-bold">{{currentComm?.amount}}</span></div>
      <div><span class="fs-3">type de la commission : </span><span
    class="fs-2 fw-bold">{{currentComm?.type=='P'?'Pourcentage':'Fixe'}}</span></div>
    <div><span class="fs-3">Montant forfaitaire : </span><span
  class="fs-2 fw-bold">{{currentComm?.flatAmount}}</span></div>
  <div><span class="fs-3">Borne inferieure: </span><span class="fs-2 fw-bold">{{currentComm?.limitInf}}</span>
</div>
<div><span class="fs-3">Borne superieure : </span><span class="fs-2 fw-bold">{{currentComm?.limitSup}}</span>
</div>
<div><span class="fs-3">Partenaire : </span><span class="fs-2 fw-bold">{{currentComm?.partner?.name}}</span>
</div>
<div><span class="fs-3">Mode de paiment : </span><span
class="fs-2 fw-bold">{{currentComm?.paymentMode?.network}}</span></div>

</div>
</div>
</div>
</div>
